import script from "./CoachMessagePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CoachMessagePopup.vue?vue&type=script&setup=true&lang=ts"

import "./CoachMessagePopup.vue?vue&type=style&index=0&id=a7c2723c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7c2723c"]])

export default __exports__